import React from 'react';
import { Heading } from '../../common/form/form-parts';
import { Button } from 'tradera/components/atoms/button/button';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export const SwedishPrivateProviderIdExists = (props) => {
    const { providerName } = props;
    return (
        <>
            <div />
            <div className={'mt-7'}>
                <Heading>
                    Ditt {providerName}-konto är redan kopplat till Tradera
                </Heading>
                <div className={'text-center mb-3'}>
                    Vill du logga in istället?
                </div>
                <Button theme="primary" fluid className="my-3" href="/login">
                    Gå till inloggning
                </Button>
                <div className={'text-center mb-3'}>
                    Har du problem? <a href={props.helpUrl}>Kontakta oss</a>
                </div>
            </div>
            <div className="text-center mb-4">
                <FormFooterLogo />
            </div>
        </>
    );
};
